import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import classnames from 'classnames';
import InputField from 'src/components/InputField';
import styles from './styles.module.scss';

type Props = {
  value: any;
  onChange: (value: any) => void;
  onBlur?: () => void;
  label: string;
  error: string;
  className?: string;
}

const PhoneInput: React.FC<Props> = ({ value, onChange, error, onBlur, label, className }) => {
  const inputMask = createNumberMask({
    integerLimit: 11,
    prefix: '+',
    includeThousandsSeparator: false,
  });
  
  const classNames = classnames(styles['input-field'], className);
  
  const handleFocus = () => {
    if (!value) {
      onChange('+7');
    }
  }
  
  const handleBlur = () => {
    if (value === '+7') {
      onChange('');
    }
  
    if(onBlur) {
      onBlur();
    }
  }
  
  return (
    <InputField
      value={value}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      error={error}
      mask={inputMask}
      label={label}
      className={classNames}
    />
  );
};

export default PhoneInput;
